import { Outlet } from "react-router";
import { AppNavbar } from "@/components/app-navbar";
import { FriendModeProvider } from "@/context/friend-mode-context";

export function AppLayout() {
  return (
    <FriendModeProvider>
      <div className="flex flex-col h-[100dvh]">
        <AppNavbar />
        <Outlet />
      </div>
    </FriendModeProvider>
  );
}
